/** Transfer types (`transfer_type_po`) accepted by the backend. */
export const TRANSFER_TYPE = [
  { name: 'Bank Transfer', value: 'bank-transfer' },
  { name: 'Cash Pickup', value: 'cash-pickup' },
  { name: 'Mobile Transfer', value: 'mobile-transfer' },
  { name: 'Wallet', value: 'wallet' },
];

export const BANK_ACCOUNT_TYPE = [
  { name: 'Savings', value: 'savings' },
  { name: 'Current', value: 'current' },
];

export const TRANSFER_TYPE_VALUE = {
  bank: 'bank-transfer',
  cashPickup: 'cash-pickup',
  mobile: 'mobile-transfer',
  wallet: 'wallet',
} as const;
